import React from "react"
import strings from "../../localization/strings"
import { TextField } from "material-ui"
import autobind from "class-autobind"
import AccountStore from "../../stores/AccountStore"
import * as accountActions from "../../actions/AccountActions"
import _ from "lodash"
interface IProps {
	type: string
}
interface IState {
	customField1Label: string
	customField2Label: string
	customField3Label: string
	customField4Label: string
	singularJobField?:string
	pluralJobField?:string
}

export default class CustomFieldLabels extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props)
		this.state = {
            customField1Label: AccountStore.getCurrentAccountSettings().CustomFieldSettings[props.type].Field1Label,
            customField2Label: AccountStore.getCurrentAccountSettings().CustomFieldSettings[props.type].Field2Label,
            customField3Label: AccountStore.getCurrentAccountSettings().CustomFieldSettings[props.type].Field3Label,
            customField4Label: AccountStore.getCurrentAccountSettings().CustomFieldSettings[props.type].Field4Label
        }
		autobind(this)
	}

	checkValidate() {
		let isValidate = true
		return isValidate
	}

	handleSave() {
        const CustomFieldSettings = AccountStore.getCurrentAccountSettings() && AccountStore.getCurrentAccountSettings().CustomFieldSettings
        CustomFieldSettings[this.props.type].Field1Label = this.state.customField1Label
        CustomFieldSettings[this.props.type].Field2Label = this.state.customField2Label
        CustomFieldSettings[this.props.type].Field3Label = this.state.customField3Label
        CustomFieldSettings[this.props.type].Field4Label = this.state.customField4Label
		accountActions.patchAccount(
			AccountStore.getCurrentAccount().Id,
			{
				AccountSettings: {
                    CustomFieldSettings
				}
			}
		)
	}

    saveCustomFieldSettings = _.debounce(() => this.handleSave(), 1500)

	render() {
		return (
            <div style={{ width: 500, padding: "20px 40px" }}>
                <TextField
                    floatingLabelText={`${strings.Custom_Field} 1 Label`}
                    value={this.state.customField1Label}
                    style={{ width: 350 }}
                    onChange={(event) => this.setState({ customField1Label: event.target.value }, () => this.saveCustomFieldSettings())}
                />
                <TextField
                    floatingLabelText={`${strings.Custom_Field} 2 Label`}
                    value={this.state.customField2Label}
                    style={{ width: 350 }}
                    onChange={(event) => this.setState({ customField2Label: event.target.value }, () => this.saveCustomFieldSettings())}
                />
                <TextField
                    floatingLabelText={`${strings.Custom_Field} 3 Label`}
                    value={this.state.customField3Label}
                    style={{ width: 350 }}
                    onChange={(event) => this.setState({ customField3Label: event.target.value }, () => this.saveCustomFieldSettings())}
                />
                <TextField
                    floatingLabelText={`${strings.Custom_Field} 4 Label`}
                    value={this.state.customField4Label}
                    style={{ width: 350 }}
                    onChange={(event) => this.setState({ customField4Label: event.target.value }, () => this.saveCustomFieldSettings())}
                />
                
            </div>
        )
	}
}